import api from "./auth";
import { showAlert } from "./alerts";

export default async function (email, password) {
  try {
    const { data } = await api.post("/api/v1/users/login", { email, password });

    showAlert("success", "Login successful!!");
    window.location.assign("/");
  } catch (error) {
    // console.log({ ERROR: error.response });
    showAlert("error", error.response.data.message);
    // window.location.assign('/login')
  }
}
